var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24808 16.6788C5.28216 10.3297 8.85256 5.45379 14.2562 3.70529C21.3594 1.40629 29.0691 5.7972 30.7232 13.0752C31.4966 16.4761 30.9225 19.6891 29.3199 22.7265C27.1721 26.7976 24.0386 29.9511 20.1178 32.3358C19.7656 32.5499 19.3803 32.7089 19.0089 32.8915C18.4304 33.1764 17.8607 33.1423 17.277 32.8845C16.0309 32.334 14.9107 31.5843 13.8447 30.7498C10.941 28.4779 8.51964 25.7918 6.85502 22.4757C5.83528 20.4432 5.24284 18.2945 5.24808 16.6788ZM7.34436 16.0156C7.33824 17.8698 7.7769 19.6253 8.58867 21.2803C10.5582 25.2972 13.6314 28.2822 17.3766 30.6423C17.9402 30.998 18.392 30.984 18.9495 30.6345C22.4963 28.4097 25.4297 25.5917 27.4246 21.878C28.7004 19.5038 29.2491 16.975 28.8262 14.2706C27.8807 8.22465 21.8698 4.11424 15.8894 5.43544C10.8763 6.54256 7.36795 10.8872 7.34436 16.0164V16.0156Z",
    fill: "#273239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1326 22.6381C14.8401 22.6075 12.1898 19.9407 12.2213 16.6892C12.2536 13.3757 14.9222 10.756 18.2418 10.7805C21.4671 10.8032 24.1217 13.5208 24.0894 16.767C24.0571 20.0219 21.3718 22.6687 18.1317 22.639L18.1326 22.6381ZM18.1457 20.5418C20.2708 20.5506 21.9922 18.8353 21.9966 16.7041C22.001 14.627 20.2717 12.8837 18.1955 12.8733C16.0512 12.8619 14.3097 14.5868 14.3132 16.7189C14.3167 18.8283 16.0258 20.5331 18.1457 20.5418Z",
    fill: "#273239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsIcon);
export default __webpack_public_path__ + "static/media/locations-icon.d38a1619909a290b09fbb71ce6248af4.svg";
export { ForwardRef as ReactComponent };